import React from 'react';
import { Box, Typography, Chip } from '@mui/material';
import { FilterList as FilterListIcon } from '@mui/icons-material';

interface CategoryFilterProps {
  categories: string[];
  selectedCategory: string;
  onCategoryChange: (category: string) => void;
}

const CategoryFilter: React.FC<CategoryFilterProps> = ({
  categories,
  selectedCategory,
  onCategoryChange
}) => {
  return (
    <Box sx={{ 
      display: 'flex', 
      justifyContent: 'center', 
      flexWrap: 'wrap', 
      gap: 1.5, 
      mb: 6,
      p: 3,
      backgroundColor: 'white',
      borderRadius: '16px',
      boxShadow: '0 4px 20px rgba(0,0,0,0.08)'
    }}>
      <Typography variant="h6" sx={{ 
        color: '#1a237e',
        fontWeight: 'bold',
        mr: 2,
        mb: { xs: 1, sm: 0 },
        width: { xs: '100%', sm: 'auto' },
        textAlign: { xs: 'center', sm: 'left' },
        display: 'flex',
        alignItems: 'center',
        gap: 1
      }}>
        <FilterListIcon /> Filter by Category:
      </Typography>
      {categories.map((category) => (
        <Chip
          key={category}
          label={category}
          onClick={() => onCategoryChange(category)}
          variant={selectedCategory === category ? 'filled' : 'outlined'}
          sx={{
            backgroundColor: selectedCategory === category ? '#1a237e' : 'transparent',
            color: selectedCategory === category ? 'white' : '#1a237e',
            borderColor: '#1a237e',
            fontWeight: selectedCategory === category ? 'bold' : 'normal',
            '&:hover': {
              backgroundColor: selectedCategory === category ? '#1a237e' : 'rgba(26, 35, 126, 0.1)',
              transform: 'translateY(-2px)',
              boxShadow: '0 4px 12px rgba(0,0,0,0.15)'
            },
            transition: 'all 0.3s ease',
            borderRadius: '20px',
            height: '40px'
          }}
        />
      ))}
    </Box>
  );
};

export default CategoryFilter;
